import { useTranslation } from "@opendash/core";
import { Select } from "antd";
import React from "react";
import { useRouteType } from "../hooks/useRouteTypes";

type CustomFormItemProps = {
  value?: number;
  onChange?: (routetype: number) => void;
};

type RouteTypeOption = {
  id: number | string;
  value: number;
  description: string;
};

const DEFAULT_ROUTE_TYPES: RouteTypeOption[] = [
  { id: 0, value: 0, description: "Straßenbahn, Stadtbahn" },
  { id: 1, value: 1, description: "U-Bahn, Metro" },
  { id: 2, value: 2, description: "Bahn" },
  { id: 3, value: 3, description: "Bus" },
  { id: 4, value: 4, description: "Fähre" },
  { id: 5, value: 5, description: "Kabelstraßenbahn" },
  {
    id: 6,
    value: 6,
    description: "Luftseilbahn, Seilschwebebahn (z. B. Gondelbahn, Pendelbahn)",
  },
  { id: 7, value: 7, description: "Standseilbahn" },
  { id: 11, value: 11, description: "Oberleitungsbus" },
  { id: 12, value: 12, description: "Einschienenbahn" },
];

/**
 * A component that renders a calendar.
 * @param value initialValue passed by parent Form.Item.
 * @param onChange a callback for Form.Item to read its child component's value.
 * @constructor
 */
export const RouteTypeSelect: React.FC<CustomFormItemProps> = ({
  value,
  onChange,
}) => {
  const t = useTranslation();
  const [routeTypes, reloadRouteTypes] = useRouteType();
  const { Option } = Select;

  let options: RouteTypeOption[] = [
    ...routeTypes.map((routetype) => ({
      id: routetype.get("id"),
      value: Number.parseInt(routetype.get("id")),
      description:
        routetype.get("description") +
        " - " +
        routetype.get("transportation_device"),
    })),
  ];

  if (options.length === 0) {
    options = DEFAULT_ROUTE_TYPES;
  }

  return (
    <Select onChange={onChange} value={value ? value : undefined}>
      {options.map((routetype) => (
        <Option key={routetype.id} value={routetype.value}>
          {routetype.description}
        </Option>
      ))}
    </Select>
  );
};
